import { render, staticRenderFns } from "./PartnerMenuSetting.vue?vue&type=template&id=322683ba&scoped=true"
import script from "./PartnerMenuSetting.vue?vue&type=script&lang=js"
export * from "./PartnerMenuSetting.vue?vue&type=script&lang=js"
import style0 from "./PartnerMenuSetting.vue?vue&type=style&index=0&id=322683ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322683ba",
  null
  
)

export default component.exports